jQuery(document).ready(function($) {
    if ($('#contact-page').length) {
        const setInputReadOnly = (input, display) => {
            if (input) {
                input.prop('readonly', true);
                const valorInput = input.val();
                const nuevoNodo = valorInput;
                display.append(nuevoNodo);
            }
        };

    if ($('#vacancyDisplay').length) {
        setInputReadOnly($('input[name="vacante"]'), $('#vacancyDisplay'));
    }

    if ($('#equipmentDisplay').length) {
        setInputReadOnly($('input[name="equipment"]'), $('#equipmentDisplay'));
    }
    }
});